function _s(o, i, p, l) {
  void 0 === i && (i = 400),
    void 0 === l && (l = !1),
    (o.style.overflow = "hidden"),
    l && (o.style.display = "block");
  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;
  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;
    l
      ? ((o.style.height = g * e + "px"),
        (o.style.paddingTop = m * e + "px"),
        (o.style.paddingBottom = h * e + "px"),
        (o.style.marginTop = u * e + "px"),
        (o.style.marginBottom = x * e + "px"))
      : ((o.style.height = s - g * e + "px"),
        (o.style.paddingTop = a - m * e + "px"),
        (o.style.paddingBottom = r - h * e + "px"),
        (o.style.marginTop = y - u * e + "px"),
        (o.style.marginBottom = d - x * e + "px")),
      i <= e
        ? ((o.style.height = ""),
          (o.style.paddingTop = ""),
          (o.style.paddingBottom = ""),
          (o.style.marginTop = ""),
          (o.style.marginBottom = ""),
          (o.style.overflow = ""),
          l || (o.style.display = "none"),
          "function" == typeof p && p())
        : window.requestAnimationFrame(t);
  });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
  (HTMLElement.prototype.slideUp = function (t, e) {
    _s(this, t, e);
  }),
  (HTMLElement.prototype.slideDown = function (t, e) {
    _s(this, t, e, !0);
  });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
    document.querySelector("body").addEventListener(
      "click",
      function (e) {
        if (
          !e.target.closest("header-drawer") &&
          !e.target.closest(".header__icons") &&
          !e.target.closest("mega-menu") &&
          !e.target.closest("#FacetFiltersFormMobile")
        ) {
          document.body.classList.remove(
            `overflow-hidden-${this.dataset.breakpoint}`
          );
          document.body.classList.remove("menu-opened");
          this.mainDetailsToggle.classList.remove("menu-opening");
          document.body.classList.remove("menu-opened");
          this.mainDetailsToggle
            .querySelectorAll("details")
            .forEach((details) => {
              details.removeAttribute("open");
              document.body.classList.remove("menu-opened");
            });
          this.closeAnimation(this.mainDetailsToggle);
        }
      }.bind(this)
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add("menu-opened");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    //console.log(event);

    if (event !== undefined) {
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      document.body.classList.remove("menu-opened");
      document.querySelector("[data-close-menu]").click();

      this.mainDetailsToggle.classList.remove("menu-opening");
      document.body.classList.remove("menu-opened");
      document.querySelector("[data-close-menu]").click();
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        document.body.classList.remove("menu-opened");
      });
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    if (event.currentTarget.classList.contains("menu-drawer__utility-links")) {
      return;
    } else {
      setTimeout(() => {});
    }
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    document.body.classList.remove("menu-opened");
    document.querySelector("[data-close-menu]").click();
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    document.body.classList.add("menu-opened");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    document.body.classList.remove("menu-opened");
    document.querySelector("[data-close-menu]").click();
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    detailsElement.removeAttribute("open");
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add("menu-opened");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateUnavailableSelectors();
    this.addEventListener("change", this.onVariantChange);
    document
      .querySelectorAll(
        ".template-product .product__info-container [data-variant-color]"
      )
      .forEach((item) => {
        item.addEventListener("click", function () {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
      });
    this.getCurrentColor();
    if (document.querySelector('.product .product__info-container .price--on-sale .price__sale')) {
      document.querySelector('.product .tag-sold')?.classList.remove('hidden');
    } else {
document.querySelector('.product .tag-sold')?.classList.add('hidden');          
    }

  }

  onVariantChange() {
    this.updateUnavailableSelectors();
    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  getCurrentColor() {
    function findGetParameter(parameterName) {
      var result = null,
        tmp = [];
      location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
      return result;
    }

    var current_color = findGetParameter("data-color");
    if (current_color) {
      var color_lower = current_color.toLowerCase();
      document
        .querySelector('[data-variant-color]:not([data-variant-color="' + color_lower + '"])')
        .click();
      setTimeout(function() {
        
      document
        .querySelector('[data-variant-color="' + color_lower + '"]')
        .click();
      }, 500)
    }
  }

  updateUnavailableSelectors() {
    document.querySelectorAll(`[data-variant-color]`).forEach((item) => {
      item.classList.remove("unavailable");
    });
    if (document.querySelector("#unavailable-variants")) {
      const unavailable = document
        .querySelector("#unavailable-variants")
        .value.split(" , ");
      var size = [];
      var color = [];

      for (const variant in unavailable) {
        var splited = unavailable[variant].split(" / ");
        // //console.log(splited);

        if (splited.length > 1) {
          color.push(unavailable[variant].split(" / ")[1]);
          size.push(unavailable[variant].split(" / ")[0]);
        } else {
          size.push(unavailable[variant].split(" / ")[0]);
        }
      }

      var revert = false;

      for (const c in color) {
        if (color[c] == "XS" || color[c] == "S" || color[c] == "XL") {
          revert = true;
        }
      }

      if (revert) {
        var tmp = color;
        var tmp2 = size;
        size = tmp;
        color = tmp2;
      }

      ////console.log(size, color);

      var actual_color = document.querySelector('[name="color"]:checked + label')?.getAttribute("data-variant-color");
      // //console.log(actual_color);

      if (!actual_color) {
        return;
      }

      document.querySelectorAll('[name="taille"][value]').forEach((item) => {
        item.classList.remove("unavailable");
      });

      for (var i = 0; i < size.length; i++) {
        var c1 = actual_color.toLowerCase();
        if (color.length > 0) {
          var c2 = color[i].toLowerCase();

          if (c1 == c2) {
            var s = size[i];
            var i1 = document.querySelector(
              `[name="taille"][value="${s.toUpperCase()}"]`
            );
            var i2 = document.querySelector(
              `[name="taille"][value="${s.toLowerCase()}"]`
            );
            ////console.log(i1, i2);
            if (i1) {
              i1.classList.add("unavailable");
            } else if (i2) {
              i2.classList.add("unavailable");
            }
          }
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );

    var fieldsets = Array.from(
      this.closest(".product__info-container").querySelectorAll("fieldset")
    );
    //console.log(fieldsets);
    var options_all = this.options.concat(
      fieldsets.map((fieldset) => {
        //console.log( Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
    this.options = options_all;
    //console.log(this.options);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          //console.log(this.options[index], option);
          return this.options[index] === option;
        })
        .includes(false);
    });
    //console.log(this.currentVariant);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        console.log(this.currentVariant);

        if (this.currentVariant.price < this.currentVariant.compare_at_price && this.currentVariant.compare_at_price != null) {
          document.querySelector('.product .tag-sold')?.classList.remove('hidden');
        } else {
document.querySelector('.product .tag-sold')?.classList.add('hidden');          
        }

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      const btn_preco =
        document.querySelector("[data-end-preco]") &&
        document
          .querySelector("[data-end-preco]")
          .getAttribute("data-end-preco")
          ? "Précommande terminée"
          : "PRÉCOMMANDER";
      const btn_presale =
        document.querySelector("[data-end-presale]") &&
        document
          .querySelector("[data-end-presale]")
          .getAttribute("data-end-presale")
          ? "Prévente terminée"
          : "RÉSERVER";

      if (document.querySelector("[data-preco]")) {
        addButtonText.textContent = btn_preco;
      } else if (document.querySelector("[data-presale]")) {
        addButtonText.textContent = btn_presale;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });

    var select = Array.from(
      this.closest(".product__info-container").querySelectorAll("select"),
      (select) => select.value
    );
    //console.log(select);
    var options_all = select.concat(this.options);

    this.options = options_all;
    //console.log(this.options);
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.setupEventListener();

    this.updateSizeAvailable();

    if (!this.closest(".grid-image__full--one")) {
      if (this.querySelector("[data-variant-color].actif")) {
        var color = this.querySelector(
          "[data-variant-color].actif"
        ).getAttribute("data-variant-color");

        this.querySelectorAll("a").forEach((a) => {
          var url = a.getAttribute("href");
          var url_splitted = url.split("&data-color=");
          var new_url = url_splitted[0];

          new_url += "&data-color=" + color;
          a.setAttribute("href", new_url);
        });
      }
    }
  }

  setupEventListener() {
    this.querySelectorAll("[data-src-img]").forEach((color) => {
      color.addEventListener("click", this.updateCardImg.bind(this));
    });
  }

  updateCardImg(event) {
    var color = event.target.getAttribute("data-variant-color");
    var card = event.target.closest("product-card");

    card.querySelectorAll("[data-card-color]").forEach((color) => {
      color.classList.add("hidden");
    });
    card
      .querySelector('[data-card-color="' + color + '"]')
      .classList.remove("hidden");

    this.querySelectorAll("[data-src-img]").forEach((color) => {
      color.classList.remove("actif");
    });

    event.target.classList.add("actif");

    this.querySelectorAll("a").forEach((a) => {
      var url = a.getAttribute("href");
      var url_splitted = url.split("&data-color=");
      var new_url = url_splitted[0];

      new_url += "&data-color=" + color;
      a.setAttribute("href", new_url);
    });

    this.updateSizeAvailable();
  }

  updateSizeAvailable() {
    if (this.querySelector(".product-card-color .actif")) {
      var actual_color = this.querySelector(
        ".product-card-color .actif"
      ).getAttribute("data-variant-color");
      this.unavailable_variants = this.querySelectorAll(
        "[unavailable-variants]"
      );

      var index = 0;

      this.unavailable_variants.forEach((item) => {
        item.classList.remove("product-card-size--unavailable");
      });

      this.unavailable_variants.forEach((item) => {
        index += 1;
        var unavailable = item
          .getAttribute("unavailable-variants")
          .split(",")
          .filter((n) => n);

        var arr = [];

        for (var i = 0; i < unavailable.length; i++) {
          arr.push(unavailable[i].split(" / "));
        }

        arr.forEach((elem) => {
          if (elem.includes(actual_color)) {
            item.classList.add("product-card-size--unavailable");
          }
        });
      });
    } else {
      this.unavailable_variants = this.querySelectorAll(
        "[unavailable-variants]"
      );

      var index = 0;

      this.unavailable_variants.forEach((item) => {
        item.classList.remove("product-card-size--unavailable");
      });

      this.unavailable_variants.forEach((item) => {
        index += 1;
        var unavailable = item
          .getAttribute("unavailable-variants")
          .split(",")
          .filter((n) => n);

        ////console.log(unavailable);

        var arr = [];

        for (var i = 0; i < unavailable.length; i++) {
          arr.push(unavailable[i].split(" / "));
        }

        arr.forEach((elem) => {
          // //console.log(elem);
          if (elem.length > 0) {
            item.classList.add("product-card-size--unavailable");
          }
        });
      });
    }
  }
}

customElements.define("product-card", ProductCard);

class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 10,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
        749: {
          slidesPerView: 3,
        },
        990: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define("collection-slider", CollectionSlider);

class MenuSlider extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 20,
      freeMode: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">0' + (index + 1) + "</span>";
        },
      },
    });
  }
}

customElements.define("menu-slider", MenuSlider);

class FooterReassurance extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this, {
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        749: {
          slidesPerView: 2,
          autoplay: {
            delay: 3000,
          },
        },
        990: {
          slidesPerView: 4,
          autoplay: {
            delay: 3000,
          },
        },
      },
    });
  }
}

customElements.define("footer-reassurances", FooterReassurance);

!(function (window) {
  var $q = function (q, res) {
      if (document.querySelectorAll) {
        res = document.querySelectorAll(q);
      } else {
        var d = document,
          a = d.styleSheets[0] || d.createStyleSheet();
        a.addRule(q, "f:b");
        for (var l = d.all, b = 0, c = [], f = l.length; b < f; b++)
          l[b].currentStyle.f && c.push(l[b]);

        a.removeRule(0);
        res = c;
      }
      return res;
    },
    addEventListener = function (evt, fn) {
      window.addEventListener
        ? this.addEventListener(evt, fn, false)
        : window.attachEvent
        ? this.attachEvent("on" + evt, fn)
        : (this["on" + evt] = fn);
    },
    _has = function (obj, key) {
      return Object.prototype.hasOwnProperty.call(obj, key);
    };
  function loadImage(el, fn) {
    var img = new Image(),
      src = el.getAttribute("data-lazy-src");
    if (src) {
      img.onload = function () {
        if (!!el.parent) el.parent.replaceChild(img, el);
        else el.src = src;

        fn ? fn() : null;
      };
      img.src = src;
      img.removeAttribute("data-lazy-src");
    }
  }

  function elementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  var images = new Array(),
    query = $q("img.lazy"),
    processScroll = function () {
      for (var i = 0; i < images.length; i++) {
        if (elementInViewport(images[i])) {
          loadImage(images[i], function () {
            images.splice(i, i);
          });
        }
      }
    };
  // Array.prototype.slice.call is not callable under our lovely IE8
  for (var i = 0; i < query.length; i++) {
    images.push(query[i]);
  }

  processScroll();
  addEventListener("scroll", processScroll);
})(this);

window.addEventListener("scroll", function () {
  if (window.scrollY > 400) {
    const videos = document.querySelectorAll("video");
    for (let i = 0; i < videos.length; i++) {
      const video = videos[i];

      video.play();
    }
  }
});

class InstaFeed extends HTMLElement {
  constructor() {
    super();

    this.images_container = document.querySelectorAll(".insta-list__image");

    window.addEventListener("load", this.getImage.bind(this));
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 2,
      breakpoints: {
        749: {
          slidesPerView: 3,
        },
        990: {
          slidesPerView: 4,
        },
        1140: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
      },
    });
  }

  getImage() {
    if (window.scrollY > 400) {
      const videos = document.querySelectorAll("video");
      for (let i = 0; i < videos.length; i++) {
        const video = videos[i];

        video.play();
      }
    }
    fetch(
      "https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=avnier.myshopify.com&resource=default"
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then(
        function (json) {
          this.injectFeed(json);
        }.bind(this)
      )
      .catch((error) => {
        ////console.log(error);
      });
  }

  injectFeed(feed) {
    ////console.log(feed);

    var index = 0;

    for (const image in feed) {
      if (index < 6) {
        var current = feed[image];
        if (current.media_url.split(".mp4").length == 1) {
          this.images_container[index]
            .querySelector("a")
            .setAttribute("href", current.permalink);
          this.images_container[index]
            .querySelector("img")
            .setAttribute("data-lazy-src", current.media_url);
          index++;
        }
      }
    }

    this.initSwiper();
    ////console.log(document.querySelector('insta-feed'));
    document.querySelector("insta-feed").setAttribute("style", "opacity: 1");
  }
}

customElements.define("insta-feed", InstaFeed);

class ToggleItems extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector(".toggle-item__header")) {
      this.querySelector(".toggle-item__header").addEventListener(
        "click",
        this.toggleItem.bind(this)
      );
    }
    window.addEventListener("load", this.setOffsetHeight.bind(this));
  }

  setOffsetHeight() {
    let height = 0;
    document
      .querySelectorAll(
        "#menu-drawer .menu-drawer__navigation .toggle-item__header"
      )
      .forEach((item) => {
        height += item.offsetHeight;
      });
    document.documentElement.style.setProperty(
      "--navigation-offset-height",
      height + "px"
    );
  }

  toggleItem() {
    this.setOffsetHeight();

    if (this.classList.contains("actif")) {
      this.classList.remove("actif");
      this.closest("toggle-item")
        .querySelector(".toggle-item__header + div")
        .slideUp(350);
    } else {
      document
        .querySelectorAll(
          ".product-description__right .toggle-item, .menu-drawer__navigation .toggle-item"
        )
        .forEach((item) => {
          if (item.classList.contains("actif")) {
            item.classList.remove("actif");
            item
              .closest("toggle-item")
              .querySelector(".toggle-item__header + div")
              .slideUp(350);
          }
        });
      this.classList.add("actif");
      this.closest("toggle-item")
        .querySelector(".toggle-item__header + div")
        .slideDown(350);
    }

    setTimeout(function () {
      laxs();
      AOS.refresh();
    }, 500);
  }
}

customElements.define("toggle-item", ToggleItems);

class ParallaxElement extends HTMLElement {
  constructor() {
    super();
    var that = this;
    window.onload = function () {
      lax.addElements(".media", {
        scrollY: {
          translateY: [
            ["elInY", "elOutY"],
            [0, -300],
          ],
        },
      });
    };
  }
}

customElements.define("parallax-element", ParallaxElement);

function laxs() {
  var laxs = document.querySelectorAll(".lax_preset_slideY");
  lax.init();
  lax.addDriver(
    "scrollY",
    function () {
      return window.scrollY;
    },
    { inertiaEnabled: true }
  );
  laxs.forEach((item) => {
    var distance =
      window.innerWidth < 990
        ? parseInt(item.getAttribute("data-lax")) / 2
        : parseInt(item.getAttribute("data-lax"));
    var id = item.getAttribute("id");
    lax.addElements("#" + id, {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [distance * -1, 0],
          {
            inertia: 1,
          },
        ],
      },
    });
  });

  if (document.querySelector("ariane-slideshow")) {
    lax.addElements(
      "ariane-slideshow .ariane-slideshow__image-container", // Element selector rule
      {
        // Animation data
        scrollY: {
          opacity: [
            [0, window.innerHeight * 0.75],
            [1, 0],
          ],
        },
      }
    );
  }

  var transform = window.innerWidth < 990 ? 300 : 600;
  lax.addElements(".main-mosaic__background", {
    scrollY: {
      translateX: [
        ["elInY", "elOutY"],
        [0, transform],
        {
          inertia: -1,
        },
      ],
    },
  });
  lax.addElements(".main-mosaic__images", {
    scrollY: {
      translateX: [
        ["elInY", "elOutY"],
        [0, -100],
        {
          inertia: -1,
        },
      ],
    },
  });
  lax.addElements(".double-img__bg", {
    scrollY: {
      translateX: [
        ["elInY", "elOutY"],
        [0, 300],
      ],
    },
  });
  lax.addElements("[parallax-right]", {
    scrollY: {
      translateX: [
        ["elInY", "elOutY"],
        [0, 300],
      ],
    },
  });
  lax.addElements("[parallax-left]", {
    scrollY: {
      translateX: [
        ["elInY", "elOutY"],
        [0, -300],
      ],
    },
  });
}

window.addEventListener("load", laxs);

class PopinVideo extends HTMLElement {
  constructor() {
    super();

    document.querySelectorAll("[open-popin-video]").forEach((video) => {
      video.addEventListener("click", this.openVideo.bind(this));
    });

    this.querySelector(".popin-video__close").addEventListener(
      "click",
      this.closePopin.bind(this)
    );
  }

  openVideo(event) {
    var target = event.currentTarget;
    var video_url = target.getAttribute("open-popin-video");
    this.querySelector("iframe").setAttribute(
      "src",
      "https://player.vimeo.com/video/" + video_url
    );
    this.classList.add("open");
    document
      .querySelector("#shopify-section-v2-popin-video")
      .classList.add("open");
  }

  closePopin(event) {
    this.classList.remove("open");
    document
      .querySelector("#shopify-section-v2-popin-video")
      .classList.remove("open");
    this.querySelector("iframe").removeAttribute("src");
  }
}

customElements.define("popin-video", PopinVideo);

function fixBatterySaverIOS() {
  Object.defineProperty(HTMLMediaElement.prototype, "playing", {
    get: function () {
      return !!(
        this.currentTime > 0 &&
        !this.paused &&
        !this.ended &&
        this.readyState > 2
      );
    },
  });

  document.body.addEventListener("click", playVideoOnLowPower);
  document.body.addEventListener("touchstart", playVideoOnLowPower);

  function playVideoOnLowPower() {
    try {
      const videoElements = document.querySelectorAll("video");
      for (i = 0; i < videoElements.length; i++) {
        if (videoElements[i].playing) {
          // video is already playing so do nothing
          // //console.log('Playing');
        } else {
          // video is not playing so play video now
          videoElements[i].play();
          //console.log('Not Playing');
        }
      }
    } catch (err) {
      //console.log(err);
    }
  }
}

function randstr(prefix) {
  return Math.random()
    .toString(36)
    .replace("0.", prefix || "");
}

function getShipmentDate(out_of_shipping_day) {
  var date = new Date();
  var working_days = [1, 2, 3, 4, 5]; // mon-fri

  if (!out_of_shipping_day && working_days.includes(date.getDay)) {
    return date;
  } else {
    date = date.addDays(1);

    var i = 0;
    while (i < 10) {
      var parsed_date = date.toISOString().split("T")[0];
      //console.log(parsed_date);
      //console.log(working_days.includes(date.getDay()), !(parsed_date in _HOLIDAYS))
      if (working_days.includes(date.getDay()) && !(parsed_date in _HOLIDAYS)) {
        return date;
      }
      date = date.addDays(1);
      i++;
    }
  }
}

function updateDeliveryDelay() {
  var container = document.querySelector(".product-delivery-infos");
  var delivery_delay = Number(container.getAttribute("date-delivery-delay")); // Shipping delay (configurable in theme settings)
  var delivery_max_hours = Number(
    container.getAttribute("date-delivery-max-hours")
  ); // Max hour for today shipment
  var span_date = container.querySelector("[data-delivery-date]");
  var out_of_shipping_day = false;

  if (container && delivery_delay && span_date) {
    var date = new Date();
    var today_h = date.getHours();

    if (today_h > delivery_max_hours) {
      out_of_shipping_day = true;
    }

    var loop = true;
    var index = 0;
    var days_to_add = 0;
    var working_days = [1, 2, 3, 4, 5]; // mon-fri

    var parsed_date = date.toISOString().split("T")[0]; // Get french date to match holidays

    date = getShipmentDate(out_of_shipping_day);

    // //console.log("SHIPMENT DATE");
    // //console.log(date);

    while (loop) {
      var parsed_date = date.addDays(days_to_add).toISOString().split("T")[0];

      ////console.log(parsed_date, (parsed_date in _HOLIDAYS));

      ////console.log(date.getDay(), working_days);

      if (
        parsed_date in _HOLIDAYS == false &&
        working_days.includes(date.getDay())
      ) {
        // Check if the day is in holidays or not working days
        index++;
        ////console.log("GOOD");
      }

      if (index == delivery_delay) {
        loop = false;
      } else {
        date = date.addDays(1);
      }
    }

    date = date.addDays(days_to_add);
    ////console.log("FINALE DATE");
    ////console.log(date);

    let options = { weekday: "long", month: "long", day: "numeric" };

    span_date.innerHTML = date.toLocaleDateString("fr-FR", options);
    container.classList.remove("hidden");
  }
}

function setCssVars() {
  var header_height = document.body.clientWidth < 750 ? 79 : 111;
  if (document.querySelector(".side-cart__footer")) {
    var sideCartFooterHeight =
      document.querySelector(".side-cart__footer").offsetHeight;
    document.documentElement.style.setProperty(
      "--sideCartFooterHeight",
      sideCartFooterHeight + "px"
    );
  }
  document.documentElement.style.setProperty(
    "--header-height",
    header_height + "px"
  );
  document.documentElement.style.setProperty(
    "--screenHeight",
    window.innerHeight + "px"
  );
}

document.addEventListener("DOMContentLoaded", function () {
  this.addEventListener("keyup", (event) => {
    if (event.code.toUpperCase() === "ESCAPE") {
      document.querySelector(".side-cart__close-button").click();
      if (document.querySelector(".product-popup-modal__toggle")) {
        document.querySelector(".product-popup-modal__toggle").click();
      }
      document.querySelector("[data-close-menu]").click();
      if (document.querySelector(".product-medias__header--close-zoom")) {
        document.querySelector(".product-medias__header--close-zoom").click();
      }
    }
  });

  document
    .querySelectorAll(
      '.media img[loading="lazy"], .blur-hover img[loading="lazy"]'
    )
    .forEach((img) => {
      img.onload = function (e) {
        img.parentNode.classList.add("loaded");
      };
      if (img.complete) {
        img.parentNode.classList.add("loaded");
      }
    });

  var styleElem = document.head.appendChild(document.createElement("style"));

  var buttons = document.querySelectorAll("[data-block-id] .button");

  const colors = ["#F4FF7A", "#F4FF7A"];

  var headers = document.querySelectorAll("toggle-item .toggle-item__header");
  headers.forEach((header) => {
    var color = colors[Math.floor(Math.random() * colors.length)];
    var id = randstr("toggle_");
    header.setAttribute("id", id);
    styleElem.innerHTML += `#${id}::after {background: ${color};}`;
  });

  var buttons_text = document.querySelectorAll(
    ".button, .main-slideshow__video-button"
  );
  buttons_text.forEach((button) => {
    var color = colors[Math.floor(Math.random() * colors.length)];
    var id = randstr("button_");
    button.setAttribute("id", id);
    styleElem.innerHTML += `#${id}::after {background: ${color};}#${id} span::after {background: ${color};}`;
  });

  var buttons_text = document.querySelectorAll(".customer-menu__link-list a");
  buttons_text.forEach((button) => {
    var color = colors[Math.floor(Math.random() * colors.length)];
    var id = randstr("button_");
    button.setAttribute("id", id);
    styleElem.innerHTML += `#${id}::after {background: ${color};}`;
  });

  setTimeout(setCssVars, 600);

  if (
    document.querySelector(".template-product") &&
    document.querySelector(".shipping-selector-countries").value == "France" &&
    document.querySelector(".product-delivery-infos")
  ) {
    if (
      document
        .querySelector(".product-delivery-infos")
        .getAttribute("date-delivery-delay")
    ) {
      updateDeliveryDelay();
    }
  }

  fixBatterySaverIOS();

  document.querySelectorAll("[data-style]").forEach((style) => {
    style.setAttribute("style", style.getAttribute("data-style"));
  });

  document.querySelectorAll("[data-aos-delay-phone]").forEach((item) => {
    if (window.innerWidth <= 749) {
      item.setAttribute(
        "data-aos-delay",
        item.getAttribute("data-aos-delay-phone")
      );
    } else {
      item.setAttribute(
        "data-aos-delay",
        item.getAttribute("data-aos-delay-desktop")
      );
    }
    AOS.refresh();
  });

  if (window.innerWidth < 990) {
    document
      .querySelectorAll(".button[href], .button--text[href]")
      .forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          var url = e.currentTarget.getAttribute("href");
          setTimeout(function () {
            window.location.href = url;
          }, 500);
        });
      });
  }

  document
    .querySelector(
      ".menu-drawer__navigation toggle-item:last-child .toggle-item__header"
    )
    .addEventListener("click", function (e) {
      var target = e.currentTarget;
      if (target.closest("toggle-item").classList.contains("actif")) {
        var objDiv = document.querySelector("#menu-drawer");
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    });

  let inputs = document.querySelectorAll("fieldset label[data-variant-color]");

  if (inputs && inputs.length > 0) {
    if (inputs.length == 1) {
      inputs[0].click();
    }
  }

  document.querySelector(".open-sizeguide")
    ? document
        .querySelector(".open-sizeguide")
        .addEventListener("click", () => {
          document.querySelector(".product-size-guide button").click();
        })
    : null;
});

window.addEventListener("resize", function () {
  setCssVars();
});

window.addEventListener("scroll", function () {
  if (document.querySelector(".template-index")) {
    if (window.scrollY > 100) {
      document.querySelector("header.header").classList.add("invert");
    } else {
      let first_color = document.querySelector(
        ".main-slideshow-left .swiper-slide-active"
      );

      if (!first_color) {
        if (
          document
            .querySelector("header.header")
            .classList.contains("no-invert")
        ) {
          document.querySelector("header.header").classList.remove("invert");
        } else {
          document.querySelector("header.header").classList.remove("invert");
        }
        if (
          document
            .querySelector("header.header")
            .classList.contains("invert-base")
        ) {
          document.querySelector("header.header").classList.add("invert");
        }
      } else {
        first_color = first_color.dataset.menu;
        if (first_color == "black") {
          document.querySelector("header").classList.add("invert");
        } else {
          document.querySelector("header").classList.remove("invert");
        }
      }
    }
  }
});
